import React, { useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import background from "../assets/meso-game-bg.png";
import RatingGameContainer from "./RatingGameContainer";
import MultipleChoicePhonics from "./MultipleChoicePhonics";
import GameResult from "./GameResultRating";
import useSpeech from "../hooks/useSpeech";
import UpdateProgress from "../functions/UpdateProgress";
import useAuth from "../../auth/hooks/useAuth";
import axios from "axios";
import { Scale } from 'react-scaling';
import useTamagotchis from "../hooks/useTamagotchis";


var questionsAnswered = [];

//used for finding correct images
var imageName = "";

export default function RatingGame({ ...props }) {
    var gottama = false;
    const tamagotchis = useTamagotchis();
    const [tama, setTama] = useState([]);
    useEffect(() => {
    if (tamagotchis != undefined && gottama == false) {
        console.log("set tama");
           setTama(tamagotchis);
           gottama = true;
        }
    }, [tamagotchis]);
      
    const [endlessCombo, setEndlessCombo] = useState(0);

    const [correctInRow, setCorrectInRow] = useState(0);
    const [game, setGame] = useState(props.game);
    const { state: authState } = useAuth();
    const [level, setLevel] = useState(props.initialLevel !== undefined ? props.initialLevel : 0);
    const [lives, setLives] = useState(3);
    const [score, setScore] = useState(0);
    const [feedback, setFeedback] = useState([]);
    const [questions, setQuestions] = useState(props.questionslist);
    const [currentQuestion, setCurrentQuestion] = useState([]);
    const [correctForLevel, setCorrectForLevel] = useState(0);
    const [correctAnswers, setCorrectAnswers] = useState(0);
    const [incorrectAnswers, setIncorrectAnswers] = useState(0);
    const [correctAnswersList, setCorrectAnswersList] = useState([]);
    const [incorrectAnswersList, setIncorrectAnswersList] = useState([]);
    const [toggle, setToggle] = useState(false);
    const [maxDifficultyLevel, setMaxDifficultyLevel] = useState(
        questions.length - 1
    );
    const [maxTime, setMaxTime] = useState(
        props.defaultTimer ? props.defaultTimer : 330
    );
    const [remainingTime, setRemainingTime] = useState(
        props.defaultTimer ? props.defaultTimer : 330
    );
    const[endlessTimer, setEndlessTimer] = useState(
        props.endlessTimer ? props.endlessTimer : 1337
    );
    const [gameover, setGameover] = useState(false);
    const [timeOnComplete, setTimeOnComplete] = useState(0);

    //const [wordToSay, setWordToSay] = useState("");
   // const { sayWord } = useSpeech();

    const[showColouredFeedback, setColouredFeedback] = useState(false);
    const [waitTime, setWaitTime] = useState(0);

    var imagebg = require('../assets/' + game.rating_background);

    props.token = authState;

    function reduceTimer() {
        console.log(waitTime);
      setWaitTime(waitTime - 1);
      }

      function sayWord(word){
        if (word != undefined && word != ""){
            word = word.toLowerCase();
          console.log("playing sound: " + word);
           var audio = new Audio("/audio/" + word + '.mp3'); 
          audio.play();
          }
      }
  
     

    const submitRating = useCallback(async () => {
        console.log(props);
        console.log(incorrectAnswersList);
        console.log(correctAnswersList);
        const parameters = {
            rating: Math.round(score),
            service_key: game.service_key
        };
        console.log(parameters);

        if (gameover === true) {
            const response = await axios({
                url: `${process.env.REACT_APP_API}/ratings`,
                method: "post",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authState.access_token}`
                },
                data: parameters
            });
            
            let average_ans_time = parseFloat((remainingTime / (correctAnswersList.length + correctAnswersList.length)).toFixed(2));
            if (average_ans_time == null){
                console.log(average_ans_time);
            }

            let correctByTopics = correctAnswersList.reduce((byTopics, question) => {
                byTopics[question.topic_id] = byTopics[question.topic_id] || [];
                byTopics[question.topic_id].push(question);
                return byTopics;
            }, {});
            let incorrectByTopics = incorrectAnswersList.reduce((byTopics, question) => {
                byTopics[question.topic_id] = byTopics[question.topic_id] || [];
                byTopics[question.topic_id].push(question);
                return byTopics;
            }, {});
            console.log(incorrectByTopics);

            window.correctByTopics = correctByTopics;
            window.incorrectByTopics = incorrectByTopics;

            let topicstats = [...(new Set([...Object.keys(correctByTopics), ...Object.keys(incorrectByTopics)]))].map(topic_id => {
                let num_correct = correctByTopics[topic_id] ? correctByTopics[topic_id].length : 0;
                let num_incorrect = incorrectByTopics[topic_id] ? incorrectByTopics[topic_id].length : 0;
                console.log("topicID");
                console.log(topic_id);
                let tempTopicID = parseInt(topic_id);
                let tempAverageAnswerTime = parseFloat(average_ans_time);
                return {
                    topic_id: tempTopicID,
                    num_correct,
                    num_asked: num_correct + num_incorrect,
                    average_ans_time: tempAverageAnswerTime
                }
            });
            console.log(topicstats);
            console.log(game);

            axios({
                url: `${process.env.REACT_APP_API}/submissions`,
                method: "post",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authState.access_token}`
                },
                data: {
                    "game_id": +game.id, 
                    "topicstats": topicstats,
                    "level_reached": level,
                    "rating": Math.round(score),
                    "platform": "Rating|WEB"+"|"+process.env.REACT_APP_VERSION_NO,
                    "questionsAnswered": JSON.stringify(questionsAnswered)
                }
            });
            //update progress
            //UpdateProgress(props);
        }
        //UPDATE XP
        console.log(tama);
        var exp = Math.round(score);
        
            var idExists = false;
            var pExp = tama.xp;
            if (pExp != undefined){
                for (let i = 0; i < pExp.length; i++) {
                    if(game.id == pExp[i].galaxyID)
                    {
                        pExp[i].playerEXP += exp;
                        exp = pExp[i].exp;
                        idExists = true;
                        break;
                    }
                }
                if(!idExists)
                {
                   var pe = {
                       galaxyID: game.id,
                       playerEXP: exp
                    }
                    console.log(pe);
                    pExp.push(pe);
                }
                console.log(pExp);

                var full = {
                    rewards: tama.rewards,
                    xp: pExp
                }

                var sendXP = JSON.stringify(full);
                axios({
                    url: `${process.env.REACT_APP_API}/playerxp`,
                    method: "post",
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${authState.access_token}`,
                        "playerxp": sendXP
                    },
                    data: {
                        "playerexp": sendXP
                    }
                });
            }
         

    }, [gameover, score]);

   
    useEffect(() => {
        if (remainingTime > 0) {
            var timerID = setInterval(() => decrementTimer(), 1000);
            return () => {
                clearInterval(timerID);
            };
        }
    }, [remainingTime]);

    function decrementTimer() {
        setRemainingTime(remainingTime - 1);
    }

    useEffect(() => {
        if(level > 9)
        {
        if (endlessTimer > 0) {
            var endlesstimerID = setInterval(() => decrementEndlessTimer(), 1000);

            
            return () => {
                clearInterval(endlesstimerID);
            };
        }
        else
        {
            submit("ranoutoftime",currentQuestion);
        }
    }
    }, [endlessTimer]);

    function decrementEndlessTimer() {
        setEndlessTimer(endlessTimer - 1);
    }

    function submit(answer, question) {
        //console.log(question);
        //console.log(answer);
if(showColouredFeedback == false)
{  if(answer != undefined){
       if (answer.correct === true) {
            setCorrectInRow(correctInRow + 1);
            setCorrectForLevel(correctForLevel + 1);
            setCorrectAnswers(correctAnswers + 1);
            setCorrectAnswersList([...correctAnswersList, currentQuestion]);

            var combocorrect = 2;
            var moveoncorrect = 9;

            let data = {
                question: question.question,
                correct: answer.correct,
                answer: answer.value
            };
            questionsAnswered.push(data);

            if(props.endless == "endless")
            {
                combocorrect = 9;
                moveoncorrect = 10;
                setEndlessCombo(endlessCombo + 1);
                if(endlessCombo >= 10)
                {
                    setLives(lives + 1);
                    setEndlessCombo(0);
                }
            }

            if (correctInRow > combocorrect || correctForLevel === moveoncorrect) {
                setLevel(level + 1);
                if(props.endless == "endless")
                {
                    if(level == 10)
                    {
                        setEndlessTimer(20);
                        setEndlessTimer(20);
                    }
                    else if(level == 11)
                    {
                        setEndlessTimer(10);
                        setEndlessTimer(10);
                    }
                    else if(level == 12)
                    {
                        setEndlessTimer(5);
                        setEndlessTimer(5);
                    }
                    else if(level == 13)
                    {
                        setEndlessTimer(3);
                        setEndlessTimer(3);
                    }
                    else if(level == 14)
                    {
                        setEndlessTimer(2);
                        setEndlessTimer(2);
                    }
                }
                else
                {
                setLives(3);
                }

                setCorrectInRow(0);
            } else {
                var endlessLevel = level;
                if(endlessLevel > 9)
                {
                    endlessLevel = 9;
                }

                if (questions[endlessLevel] !== undefined) {
                    setCurrentQuestion(
                        questions[endlessLevel][
                        Math.floor(Math.random() * questions[endlessLevel].length)
                        ]
                    );
                    if(props.endless == "endless")
                {
                    if(level == 10)
                    {
                        setEndlessTimer(20);
                        setEndlessTimer(20);
                    }
                    else if(level == 11)
                    {
                        setEndlessTimer(10);
                        setEndlessTimer(10);
                    }
                    else if(level == 12)
                    {
                        setEndlessTimer(5);
                        setEndlessTimer(5);
                    }
                    else if(level == 13)
                    {
                        setEndlessTimer(3);
                        setEndlessTimer(3);
                    }
                    else if(level == 14)
                    {
                        setEndlessTimer(2);
                        setEndlessTimer(2);
                    }
                }
                }
            }
        } else {
            setIncorrectAnswers(incorrectAnswers + 1);
            setCorrectInRow(0);
            if(props.endless == "endless")
            {
                setEndlessCombo(0);
            }
            setLives(lives - 1);
            setIncorrectAnswersList([...incorrectAnswersList, currentQuestion]);

            let data = {
                question: question.question,
                correct: answer.correct,
                answer: answer.value
            };
            questionsAnswered.push(data);

            let correctAnswer = question.answers.filter(answer => {
                return answer.correct === true;
            });
            if(answer == "ranoutoftime")
            {
                let result = {
                    question: question.question.replace("$", "_"),
                    correct: correctAnswer[0].value,
                    incorrect: "ran out of time"
                };

                setFeedback([...feedback, result]);
                setColouredFeedback(true);
                setWaitTime(2);
            }
            else{
            let result = {
                question: question.question.replace("$", "_"),
                correct: correctAnswer[0].value,
                incorrect: answer.value
            };

            setFeedback([...feedback, result]);
            setColouredFeedback(true);
            setWaitTime(2);
        }
            /*setCurrentQuestion(
                questions[level][Math.floor(Math.random() * questions[level].length)]
            );*/
        }
        }
    }
    }
    useEffect(() => {
        if(lives > 0)
        {
        if (waitTime > 0) {
            var waitttimerID = setInterval(() => reduceTimer(), 1000);
            return () => {
                clearInterval(waitttimerID);
            };
        } else {
    
            setColouredFeedback(false);
            var endlessLevel = level;
            if(endlessLevel > 9)
            {
                endlessLevel = 9;
            }

            if (questions[endlessLevel] !== undefined) {
                setCurrentQuestion(
                    questions[endlessLevel][
                    Math.floor(Math.random() * questions[endlessLevel].length)
                    ]
                );
                if(props.endless == "endless")
                {
                    if(level == 10)
                    {
                        setEndlessTimer(20);
                        setEndlessTimer(20);
                    }
                    else if(level == 11)
                    {
                        setEndlessTimer(10);
                        setEndlessTimer(10);
                    }
                    else if(level == 12)
                    {
                        setEndlessTimer(5);
                        setEndlessTimer(5);
                    }
                    else if(level == 13)
                    {
                        setEndlessTimer(3);
                        setEndlessTimer(3);
                    }
                    else if(level == 14)
                    {
                        setEndlessTimer(2);
                        setEndlessTimer(2);
                    }
                }
            }
        }
    }
      },[waitTime]);

    // set the first question
    useEffect(() => {
        if (questions !== undefined) {
            setCurrentQuestion(questions[0][0]);
        }
    }, []);

    useEffect(() => {
        if (level !== 0) {
            //award 150 pts for each level increase
            setScore(score + 150);
        }
        if(props.endless == "endless")
        {
            setMaxDifficultyLevel(14);
        }

        // if completed the game
        if (level > maxDifficultyLevel) {
            setTimeOnComplete(remainingTime);
            let totalAnswers = correctAnswers + incorrectAnswers;
            let numAnswersScore = (110 - totalAnswers) * 3;

            // add 150 for the final score increase
            let finalScore = numAnswersScore + timeOnComplete + 150;
            setScore(score + finalScore);
            setGameover(true);
        } else {
            setCorrectForLevel(0);
            var endlessLevel = level;
            if(endlessLevel > 9)
            {
                endlessLevel = 9;
            }

            if (questions !== undefined && questions[endlessLevel] !== undefined) {
               
               
                if(props.endless == "endless")
                {
                    if(level == 10)
                    {
                        setEndlessTimer(20);
                        setEndlessTimer(20);
                    }
                    else if(level == 11)
                    {
                        setEndlessTimer(10);
                        setEndlessTimer(10);
                    }
                    else if(level == 12)
                    {
                        setEndlessTimer(5);
                        setEndlessTimer(5);
                    }
                    else if(level == 13)
                    {
                        setEndlessTimer(3);
                        setEndlessTimer(3);
                    }
                    else if(level == 14)
                    {
                        setEndlessTimer(2);
                        setEndlessTimer(2);
                    }
                }

                setCurrentQuestion(
                    questions[endlessLevel][Math.floor(Math.random() * questions[endlessLevel].length)]
                );
                console.log(questions);
            }
        }
    }, [level]);

    useEffect(() => {
        if (
            currentQuestion !== undefined &&
            currentQuestion.answers !== undefined
        ) {
        if(level >= 2 && level < 4){imageName = currentQuestion.question + ".png";}
            const correctAnswer = currentQuestion.answers.filter(answer => {
                return answer.correct === true;
            });
            var newWord;
            sayWord(newWord);
        }
    }, [currentQuestion]);

    useEffect(() => {
        if (gameover == true) {
            submitRating();
            UpdateProgress(props);
            
        }
    }, [gameover]);

    useEffect(() => {
        if (lives === 0) {
            //failed the game
            setTimeOnComplete(remainingTime);
            let failedScore = correctForLevel / 9;
            let finalScore = failedScore * 150;
            setScore(score + finalScore);
            setGameover(true);
            submitRating();
        }
    }, [lives]);

    function restartGame() {
        setWaitTime(0);
        gottama = false;
        setCorrectAnswersList([]);
        setIncorrectAnswersList([]);
        setCorrectInRow(0);
        setLevel(0);
        setLives(3);
        setScore(0);
        setFeedback([]);
        setCorrectForLevel(0);
        setIncorrectAnswers(0);
        setCorrectAnswers(0);
        setRemainingTime(maxTime);
        setGameover(false);
        setTimeOnComplete(0);
        /*setCurrentQuestion(
            questions[level][Math.floor(Math.random() * questions[level].length)]
        );*/
    }

    //remove .pnmg from the question so it can be displayed correctly
     function removePNG(){
    console.log(questions);
    var newQ = questions;
    
        for(var i = 0; i < questions.length; i++){
            for(var j = 0; j < questions[i].length; j++){
               if(newQ[i][j].question.includes(".png")){
                  newQ[i][j].question = newQ[i][j].question.replace(".png", "");
                  newQ[i][j].answers.forEach(answer => {
                    answer.image = answer.value;
                  });
                  console.log(newQ[i][j]);
			   }else{
                newQ[i][j].answers.forEach(answer => {
                    answer.image = null;
                  });
               } 
			}  
		}
        
        //setQuestions(newQ);
        console.log(questions)
	}

     useEffect(() =>{
        removePNG();
	}, [])

    return (
        <RatingGameContainer
            correctInRow={correctInRow}
            level={level}
            lives={lives}
            timer={endlessTimer}
            endless={props.endless}
            onBack={() => props.onBack()}
            restart={() => {
                setCorrectInRow(0);
                setLevel(0);
                setLives(3);
            }}
        >




            {!gameover ? (
                <div style={{ backgroundImage: `url(${imagebg})`, backgroundSize: "cover", height: "100%" }} >
                    <Scale scaleTo={2220}>
                        <div>
                            <Body style={{ backgroundImage: `url()` }}>
                    {currentQuestion !== undefined && (
                                    <MultipleChoicePhonics
                                        currentQuestion={currentQuestion}
                                        onSubmit={submit}
                                        onShowFeedback={showColouredFeedback}
                                        playAudio={props.playAudio}
                                        replay={() => sayWord(currentQuestion.question)}
                                        saySentence={() => {
                                            sayWord(currentQuestion.question);
                                            setToggle(!toggle);
                                        }}
                                    />
                                )}
                            </Body>
                        </div>
                    </Scale>
                </div>
            ) : (
                    <GameResult
                        level={level}
                        feedback={feedback}
                        score={Math.round(score)}
                        correct={correctAnswers}
                        incorrect={incorrectAnswers}
                        endless={props.endless}
                        questionFontSize="0.7em"
                        onRestartGame={() => restartGame()}
                        onBack={() => props.onBack()}
                        speed={parseFloat(
                            (maxTime - timeOnComplete) / (incorrectAnswers + correctAnswers)
                        ).toFixed(2)}
                    />
                )}



        </RatingGameContainer>
    );
}

const Body = styled.div`
    width: 100%;
    height: 100%;
    background-image: url(${background});
    background-size: cover;
    background-position: 0px -1px;
    display: flex;
    justify-content: center;
    padding-top: 100px;
`;


